import styled from 'styled-components';

export const ProductsPageWrapper = styled.div`
  padding: 3rem;
  margin-top: 90px;

  @media (max-width: 800px) {
    padding: 2rem;
  }
`

export const Title = styled.h1`
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 1rem;
  font-family: 'FigtreeBold', sans-serif;
`;

export const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  padding: 2rem;
  font-family: 'Figtree', sans-serif;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;
